<template>
  <modal width="40%" :title="$t(title)" :visible.sync="isShowDialog">
    <el-form
      ref="form"
      :model="dioForm"
      style="position:relative"
      :rules="rules"
      label-width="160px"
    >

      <el-form-item :label="$t('public.table_scope')" :prop="'sceneId'"
        v-if="sysAdmin === 'isSysAdmin' || sysAdmin === 'isSysNoAdmin'"
      >
        <el-select
          v-model="dioForm.sceneId"
          style="width:250px"
          :placeholder="$t('public.please')"
        >
          <el-option
            v-for="item in scopeArray"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <!-- <span v-else>{{ textChange(dioForm.sceneId, 's') }}</span> -->
      </el-form-item>
      <!-- 气体编码 -->
      <el-form-item
          :label="$t('integration.gas_code')"
          :prop="'gasCode'"
        >
          <el-input
            type="text"
            v-model.trim="dioForm.gasCode"
            :placeholder="$t('public.please')"
            style="width:250px"
          ></el-input>
          <!-- <span v-else>{{ dioForm.gasCode }}</span> -->
        </el-form-item>
        <!-- 气体类型 -->
        <el-form-item :label="$t('integration.gas_type')" prop="type">
          <el-select
            v-model="dioForm.type"
            style="width:250px"
            :placeholder="$t('public.please')"
          >
            <el-option
              v-for="item in typeArray"
              :key="item.value"
              :label="`${$t(deviceTypeListConvert[item.code])}`"
              :value="item.value"
            ></el-option>
          </el-select>
          <!-- <span v-else>
            <span>{{ textChange(dioForm.type, 't') }}</span>
          </span> -->
        </el-form-item>
        <!-- 采集间隔 -->
        <el-form-item
          :label="$t('device.sample_interval')"
          prop="collectInterval"
        >
          <el-input
            v-model.trim="dioForm.collectInterval"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
        </el-form-item>
        <!-- 报警阈值 -->
        <template v-if="dioForm.type !== 6">
          <el-form-item
            :label="$t('integration.alarm_threshold')"
            prop="alarmThreshold"
          >
            <el-input
              v-model.trim="dioForm.alarmThreshold"
              style="width: 250px"
              maxlength="50"
              :placeholder="$t('public.please_enter')"
            />
          </el-form-item>
        </template>
        <!-- 二氧化碳参数有些不用 -->
        <template v-else>
          <el-form-item
            :label="$t('device.normal_reporting_interval')"
            prop="normalReportInterval"
          >
            <el-input
              v-model.trim="dioForm.normalReportInterval"
              style="width: 250px"
              maxlength="50"
              :placeholder="$t('public.please_enter')"
            />
          </el-form-item>
          <el-form-item
            :label="$t('device.abnormal_reporting_interval')"
            prop="abnormalReportInterval"
          >
            <el-input
              v-model.trim="dioForm.abnormalReportInterval"
              style="width: 250px"
              maxlength="50"
              :placeholder="$t('public.please_enter')"
            />
          </el-form-item>
          <el-form-item :label="$t('device.time_zone')" prop="timeZone">
              <el-select v-model="dioForm.timeZone" style="width: 250px">
                  <el-option v-for="item in shiquArray" :key="item.code"
                      :label="`${$t(shiquArrayConvert(item.code))}`" :value="item.code"> </el-option>
              </el-select>
          </el-form-item>
        </template>
        <el-form-item :label="$t('public.table_desc')" prop="description">
          <el-input
            v-model.trim="dioForm.description"
            style="width: 86%"
            maxlength="250"
            show-word-limit
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8 }"
            :placeholder="$t('public.please_enter')"
          />
        </el-form-item>
    </el-form>
    <div slot="footer">
      <el-row style="z-index: -0">
        <el-col :span="24">
          <el-button type="primary" @click="isShowDialog = false"
            >{{ $t('public.btn_close') }}
          </el-button>
          <el-button type="primary" @click="handleSave"
            >{{ $t('public.btn_confirm') }}
          </el-button>
        </el-col>
      </el-row>
    </div>
  </modal>
</template>

<script>
import { AddGas, updateGas } from '@/api/modules/sensor.js'
import addRules from '@/pages/equipment/validate/addRules.js'
import { shareScope } from '@/api/modules/public'
import { getPermission } from '@/utils/permission'
import { fourGSesnorMode, secGenZigbeeTempMode, deviceTypeListConvert, shiquArrayConvert } from '@/utils/convert'
import { RuleRequiredFunc } from '@/utils/rules'
import { soundLightAlarmConfigDefault } from '@/pages/equipment/sensor/components/sensor/cionfig/4GTempTab/default'
import { fourGSensorAlarmLevel } from '@/utils/dict/sensor'
import { humpObject } from '@/utils/common'

export default {
  props: ['title', 'isShowUnDialog', 'optareStatus', 'editObj', 'deviceType', 'shiquArray'],
  computed: {
    fourGSensorAlarmLevel () {
      return fourGSensorAlarmLevel
    },
    fourGSesnorMode () {
      return fourGSesnorMode
    },
    secGenZigbeeTempMode () {
      return secGenZigbeeTempMode
    },
    deviceTypeListConvert: () => deviceTypeListConvert,
    shiquArrayConvert: () => shiquArrayConvert,
    isShowDialog: {
      get: function () {
        return this.isShowUnDialog
      },
      set: function (val) {
        this.$emit('update:isShowUnDialog', val)
      }
    },
    rules () {
       return {
        sceneId: [
          {
            required: true,
            message: $t('integration.customer_cannot_be_empty'),
            trigger: 'change'
          }
        ],
        gasCode: [
          {
            required: true,
            message: $t('integration.number_cannot_be_empty'),
            trigger: 'blur'
          },
          {
            max: 30,
            message: $t('integration.number_length_cannot_be_greater_than_30'),
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: $t('integration.type_cannot_be_empty'),
            trigger: 'change'
          }
        ],
        collectInterval: [
            {
              required: true,
              message: $t('integration.collection_interval_cannot_be_empty'),
              trigger: 'blur'
            }
          ],
          alarmThreshold: [
            {
              required: true,
              message: $t('integration.alarm_threshold') + $t('integration.cannot_be_empty'),
              trigger: 'blur'
            }
          ],
        normalReportInterval: [
          {
            required: true,
            message: $t('device.normal_reporting_interval') + $t('integration.cannot_be_empty'),
            trigger: 'blur'
          }
        ],
        abnormalReportInterval: [
          {
            required: true,
            message: $t('device.abnormal_reporting_interval') + $t('integration.cannot_be_empty'),
            trigger: 'blur'
          }
        ],
        timeZone: [
          {
            required: true,
            message: $t('device.time_zone') + $t('integration.cannot_be_empty'),
            trigger: 'blur'
          }
        ]
       }
    },
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      return getPermission()
    }
  },
  watch: {
    editObj (newVal) {
      const appConfig = humpObject(newVal.appConfig || {})
      const sensor = humpObject(newVal.sensor || {})
      // this.dioForm.sceneId = sensor.sceneId
      // this.dioForm.tagId = sensor.tagId

      this.dioForm = { ...newVal,  sceneId: String(newVal.sceneId) }
    }
  },
  data () {
    return {
      dioForm: {
        sceneId: null,
        gasCode: null,
        type: null,
        collectInterval: null,
        description: null,
        alarmThreshold: null,
        normalReportInterval: null,
        abnormalReportInterval: null,
        timeZone: '+8',
      },
      scopeArray: [],
      typeArray: [],
      typeId: null
    }
  },
  mounted () {
    this.getSence()
    this.typeArray = [...this.deviceType]
  },
  methods: {
    RuleRequiredFunc,
    clearValidate () {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    async handleSave () {
      const flag = await this.justify()
      if (!flag) return
      for (const key in this.dioForm) {
        if (this.dioForm[key] === null) {
          delete this.dioForm[key]
        }
      }

      // 保存时增加一个typeCode参数
      let index = this.typeArray.findIndex(_ => _.id === this.dioForm.type)
      this.dioForm.typeCode = this.typeArray[index].code

      let HttpUrl = AddGas
      if (this.optareStatus === 'edit') {
        HttpUrl = updateGas
      }
      HttpUrl(this.dioForm).then(async ({ state }) => {
        await this.$resultHandle(state)
        this.isShowDialog = false
        this.$parent.getListFn()
      })
    },
    textChange (value, key) {
      let str = ''
      if (key === 's') {
        this.scopeArray.forEach(item => {
          if (item.id === String(value)) {
            str = item.name
          }
        })
      } else {
        this.typeArray.forEach(item => {
          if (item.value === value) {
            str = item.name
          }
        })
      }
      return this.$t(str)
    },
    getSence () {
      shareScope({ tab: 1 }).then(res => {
        if (res.state.code == 200) {
          this.scopeArray = res.result.filter(item => {
            return item.id > 0
          })
        }
      })
    },
  }
}
</script>

<style></style>
